module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"url":"URL","pv":"PV count","pvVisit":"Visits","uniqueUsers":"Users"},"ja":{"url":"URL","pv":"PV数","pvVisit":"訪問数","uniqueUsers":"ユーザ数"},"zh-hant":{"url":"URL","pv":"頁面瀏覽數","pvVisit":"訪問數","uniqueUsers":"使用者數"},"zh-hans":{"url":"URL","pv":"页面浏览数","pvVisit":"访问量","uniqueUsers":"用户数"}}')
  delete Component.options._Ctor
}
